import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { slot: "body" }
const _hoisted_2 = { class: "upgrade-modal__body" }
const _hoisted_3 = { class: "columns is-4" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "upgrade-modal__feature" }
const _hoisted_6 = { class: "upgrade-modal__feature-header" }
const _hoisted_7 = { class: "upgrade-modal__feature-body" }
const _hoisted_8 = { class: "column" }
const _hoisted_9 = { class: "upgrade-modal__feature" }
const _hoisted_10 = { class: "upgrade-modal__feature-body" }
const _hoisted_11 = { slot: "buttons" }

import { computed } from 'vue';
import FlowIcon from 'vue-material-design-icons/Waves.vue';
import appInsights from '@/shared/services/appInsights';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'UpgradeModal',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);

const emit = __emit;

function closeUpgradeModal() {
  emit('close');
}

function chatWithUsClicked() {
  appInsights.trackEvent({ name: 'Upgrade modal: "chat with us" clicked' }, { workspaceId: currentWorkspace.value.id });
  window.open(
    'https://www.netcall.com/liberty-connect-custom-flows-and-triage-bots?openConversation=true&utm_source=connect&utm_campaign=subscription_upgrade',
    '_blank',
  );
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_button_group = _resolveComponent("n-button-group")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createBlock(_component_n_modal, {
    class: "upgrade-modal",
    onCancel: closeUpgradeModal
  }, {
    default: _withCtx(() => [
      _cache[15] || (_cache[15] = _createElementVNode("div", { slot: "title" }, [
        _createElementVNode("div", { class: "upgrade-modal__header" }, [
          _createElementVNode("h2", null, "Upgrade to unlock these features"),
          _createElementVNode("p", null, " Your subscription doesn't cover these features. To benefit from the full power of Liberty Connect, our sales team would be happy to help you upgrade. ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(FlowIcon),
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "title" }, "Flows", -1))
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _cache[5] || (_cache[5] = _createElementVNode("h4", null, "Scale every part of your business", -1)),
                  _cache[6] || (_cache[6] = _createElementVNode("p", null, "Automate and personalise your digital experience", -1)),
                  _cache[7] || (_cache[7] = _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "20",
                        height: "15",
                        viewBox: "0 0 20 15",
                        fill: "none"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M7.143 14.886L0 7.743L2.014 5.729L7.143 10.843L17.986 0L20 2.029L7.143 14.886Z",
                          fill: "#FF6666"
                        })
                      ]),
                      _createTextVNode("Design your own conversation flow ")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "20",
                        height: "15",
                        viewBox: "0 0 20 15",
                        fill: "none"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M7.143 14.886L0 7.743L2.014 5.729L7.143 10.843L17.986 0L20 2.029L7.143 14.886Z",
                          fill: "#FF6666"
                        })
                      ]),
                      _createTextVNode("Triage conversations automatically ")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "20",
                        height: "15",
                        viewBox: "0 0 20 15",
                        fill: "none"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M7.143 14.886L0 7.743L2.014 5.729L7.143 10.843L17.986 0L20 2.029L7.143 14.886Z",
                          fill: "#FF6666"
                        })
                      ]),
                      _createTextVNode("Proactively capture more leads 24/7 ")
                    ])
                  ], -1)),
                  _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (chatWithUsClicked()))
                  }, [...(_cache[4] || (_cache[4] = [
                    _createTextVNode("Find out how ", -1),
                    _createElementVNode("svg", {
                      viewBox: "0 0 27 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        d: "M15.373 2.635l9.531 10.237-9.992 9.765M24.344 13H-.001",
                        stroke: "#f66",
                        "stroke-width": "2"
                      })
                    ], -1)
                  ]))])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "upgrade-modal__feature-header" }, [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    "enable-background": "new 0 0 24 24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    width: "24"
                  }, [
                    _createElementVNode("g", null, [
                      _createElementVNode("rect", {
                        fill: "none",
                        height: "24",
                        width: "24"
                      })
                    ]),
                    _createElementVNode("g", null, [
                      _createElementVNode("g", null, [
                        _createElementVNode("path", { d: "M15.82,7.22l-1,0.4c-0.21-0.16-0.43-0.29-0.67-0.39L14,6.17C13.98,6.07,13.9,6,13.8,6h-1.6c-0.1,0-0.18,0.07-0.19,0.17 l-0.15,1.06c-0.24,0.1-0.47,0.23-0.67,0.39l-1-0.4c-0.09-0.03-0.2,0-0.24,0.09l-0.8,1.38c-0.05,0.09-0.03,0.2,0.05,0.26l0.85,0.66 C10.02,9.73,10,9.87,10,10c0,0.13,0.01,0.26,0.03,0.39l-0.84,0.66c-0.08,0.06-0.1,0.17-0.05,0.25l0.8,1.39 c0.05,0.09,0.15,0.12,0.25,0.09l0.99-0.4c0.21,0.16,0.43,0.29,0.68,0.39L12,13.83c0.02,0.1,0.1,0.17,0.2,0.17h1.6 c0.1,0,0.18-0.07,0.2-0.17l0.15-1.06c0.24-0.1,0.47-0.23,0.67-0.39l0.99,0.4c0.09,0.04,0.2,0,0.24-0.09l0.8-1.39 c0.05-0.09,0.03-0.19-0.05-0.25l-0.83-0.66C15.99,10.26,16,10.13,16,10c0-0.14-0.01-0.27-0.03-0.39l0.85-0.66 c0.08-0.06,0.1-0.17,0.05-0.26l-0.8-1.38C16.02,7.22,15.91,7.19,15.82,7.22z M13,11.43c-0.79,0-1.43-0.64-1.43-1.43 S12.21,8.57,13,8.57s1.43,0.64,1.43,1.43S13.79,11.43,13,11.43z" }),
                        _createElementVNode("path", { d: "M19.94,9.06c-0.43-3.27-3.23-5.86-6.53-6.05C13.27,3,13.14,3,13,3C9.47,3,6.57,5.61,6.08,9l-1.93,3.48 C3.74,13.14,4.22,14,5,14h1v2c0,1.1,0.9,2,2,2h1v3h7v-4.68C18.62,15.07,20.35,12.24,19.94,9.06z M14.89,14.63L14,15.05V19h-3v-3H8 v-4H6.7l1.33-2.33C8.21,7.06,10.35,5,13,5c2.76,0,5,2.24,5,5C18,12.09,16.71,13.88,14.89,14.63z" })
                      ])
                    ])
                  ]),
                  _createElementVNode("span", { class: "title" }, "FAQs")
                ], -1)),
                _createElementVNode("div", _hoisted_10, [
                  _cache[9] || (_cache[9] = _createElementVNode("h4", null, "24/7 automated support with FAQs", -1)),
                  _cache[10] || (_cache[10] = _createElementVNode("p", null, "Support automation that resolves the most common questions for you", -1)),
                  _cache[11] || (_cache[11] = _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "20",
                        height: "15",
                        viewBox: "0 0 20 15",
                        fill: "none"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M7.143 14.886L0 7.743L2.014 5.729L7.143 10.843L17.986 0L20 2.029L7.143 14.886Z",
                          fill: "#FF6666"
                        })
                      ]),
                      _createTextVNode("Speed up customer resolutions ")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "20",
                        height: "15",
                        viewBox: "0 0 20 15",
                        fill: "none"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M7.143 14.886L0 7.743L2.014 5.729L7.143 10.843L17.986 0L20 2.029L7.143 14.886Z",
                          fill: "#FF6666"
                        })
                      ]),
                      _createTextVNode("Easy to train automation ")
                    ]),
                    _createElementVNode("li", null, [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "20",
                        height: "15",
                        viewBox: "0 0 20 15",
                        fill: "none"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          "clip-rule": "evenodd",
                          d: "M7.143 14.886L0 7.743L2.014 5.729L7.143 10.843L17.986 0L20 2.029L7.143 14.886Z",
                          fill: "#FF6666"
                        })
                      ]),
                      _createTextVNode("Eliminate repetitive work ")
                    ])
                  ], -1)),
                  _createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (chatWithUsClicked()))
                  }, [...(_cache[8] || (_cache[8] = [
                    _createTextVNode("Read more ", -1),
                    _createElementVNode("svg", {
                      viewBox: "0 0 27 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("path", {
                        d: "M15.373 2.635l9.531 10.237-9.992 9.765M24.344 13H-.001",
                        stroke: "#f66",
                        "stroke-width": "2"
                      })
                    ], -1)
                  ]))])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_n_button_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_n_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (chatWithUsClicked())),
              variant: "primary"
            }, {
              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                _createTextVNode("Chat with us", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_n_button, {
              variant: "primary--outline",
              onClick: closeUpgradeModal
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode("Cancel", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})